import { render, staticRenderFns } from "./WpQuery.vue?vue&type=template&id=ff7f08a8&"
import script from "./WpQuery.vue?vue&type=script&lang=ts&"
export * from "./WpQuery.vue?vue&type=script&lang=ts&"
import style0 from "./WpQuery.vue?vue&type=style&index=0&id=ff7f08a8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports